import enActions from './domains/actions/en';
import plActions from './domains/actions/pl';
import enAge from './domains/age/en';
import plAge from './domains/age/pl';
import enApp from './domains/app/en';
import plApp from './domains/app/pl';
import enAttr from './domains/attr/en';
import plAttr from './domains/attr/pl';
import enBiome from './domains/biome/en';
import plBiome from './domains/biome/pl';
import enBattle from './domains/battle/en';
import plBattle from './domains/battle/pl';
import enBuildings from './domains/buildings/en';
import plBuildings from './domains/buildings/pl';
import enConfig from './domains/config/en';
import plConfig from './domains/config/pl';
import enDeposit from './domains/deposit/en';
import plDeposit from './domains/deposit/pl';
import enForest from './domains/forest/en';
import plForest from './domains/forest/pl';
import enFounding from './domains/founding/en';
import plFounding from './domains/founding/pl';
import enJobs from './domains/jobs/en';
import plJobs from './domains/jobs/pl';
import enLang from './domains/lang/en';
import plLang from './domains/lang/pl';
import enLog from './domains/log/en';
import plLog from './domains/log/pl';
import enMenu from './domains/menu/en';
import plMenu from './domains/menu/pl';
import enNames from './domains/names/en';
import plNames from './domains/names/pl';
import enOverlay from './domains/overlay/en';
import plOverlay from './domains/overlay/pl';
import enProduction from './domains/production/en';
import plProduction from './domains/production/pl';
import enPrompt from './domains/prompt/en';
import plPrompt from './domains/prompt/pl';
import enResource from './domains/resource/en';
import plResource from './domains/resource/pl';
import enScout from './domains/scout/en';
import plScout from './domains/scout/pl';
import enSettings from './domains/settings/en';
import plSettings from './domains/settings/pl';
import enSettlement from './domains/settlement/en';
import plSettlement from './domains/settlement/pl';
import enTabs from './domains/tabs/en';
import plTabs from './domains/tabs/pl';
import enTier from './domains/tier/en';
import plTier from './domains/tier/pl';
import enTile from './domains/tile/en';
import plTile from './domains/tile/pl';
import enTools from './domains/tools/en';
import plTools from './domains/tools/pl';
import enTutorial from './domains/tutorial/en';
import plTutorial from './domains/tutorial/pl';
import enTooltip from './domains/tooltip/en';
import plTooltip from './domains/tooltip/pl';
import enWildlife from './domains/wildlife/en';
import plWildlife from './domains/wildlife/pl';

export type Language = 'en' | 'pl';

type TranslationDict = Record<string, string>;

export const translations: Record<Language, TranslationDict> = {
    en: {
        ...enActions,
        ...enAge,
        ...enApp,
        ...enAttr,
        ...enBiome,
        ...enBattle,
        ...enBuildings,
        ...enConfig,
        ...enDeposit,
        ...enForest,
        ...enFounding,
        ...enJobs,
        ...enLang,
        ...enLog,
        ...enMenu,
        ...enNames,
        ...enOverlay,
        ...enProduction,
        ...enPrompt,
        ...enResource,
        ...enScout,
        ...enSettings,
        ...enSettlement,
        ...enTabs,
        ...enTier,
        ...enTile,
        ...enTools,
        ...enTutorial,
        ...enTooltip,
        ...enWildlife,
    },
    pl: {
        ...plActions,
        ...plAge,
        ...plApp,
        ...plAttr,
        ...plBiome,
        ...plBattle,
        ...plBuildings,
        ...plConfig,
        ...plDeposit,
        ...plForest,
        ...plFounding,
        ...plJobs,
        ...plLang,
        ...plLog,
        ...plMenu,
        ...plNames,
        ...plOverlay,
        ...plProduction,
        ...plPrompt,
        ...plResource,
        ...plScout,
        ...plSettings,
        ...plSettlement,
        ...plTabs,
        ...plTier,
        ...plTile,
        ...plTools,
        ...plTutorial,
        ...plTooltip,
        ...plWildlife,
    },
};

function formatValue(value: string | number, format: string): string {
    if (format === 's') return String(value);
    if (format === 'd') return String(Math.round(Number(value)));
    const num = Number(value);
    if (format === 'f') return num.toFixed(2);
    if (format.startsWith('f.')) {
        const digits = Number(format.split('.')[1]);
        return num.toFixed(Number.isFinite(digits) ? digits : 2);
    }
    return String(value);
}

export function formatMessage(template: string, args: Array<string | number>): string {
    let index = 0;
    return template.replace(/%(\.\d+)?[sdf]/g, (match, precision) => {
        if (index >= args.length) return match;
        const type = match[match.length - 1];
        const arg = args[index++];
        if (type === 'f' && precision) {
            return formatValue(arg, `f.${precision.slice(1)}`);
        }
        return formatValue(arg, type);
    });
}

export function t(lang: Language, key: string, ...args: Array<string | number>): string {
    const dict = translations[lang] || translations.en;
    const template = dict[key] || translations.en[key] || key;
    if (!args.length) return template;
    return formatMessage(template, args);
}

export function getList(lang: Language, key: string, delimiter = '|'): string[] {
    const raw = t(lang, key);
    if (!raw || raw === key) return [];
    return raw
        .split(delimiter)
        .map((item) => item.trim())
        .filter((item) => item.length > 0);
}
